import { createContext, ReactNode, useContext } from "react";

import { useFilterCardCategory } from "./filter-card-category.hook";

const FilterCardCategoryContext = createContext(
  {} as ReturnType<typeof useFilterCardCategory>
);
export function useFilterCardCategoryContext() {
  return useContext(FilterCardCategoryContext);
}

interface FilterCardCategoryProviderProps {
  children: ReactNode;
}
export function FilterCardCategoryProvider({
  children,
}: FilterCardCategoryProviderProps) {
  return (
    <FilterCardCategoryContext.Provider value={useFilterCardCategory()}>
      {children}
    </FilterCardCategoryContext.Provider>
  );
}